// import React, { useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
// } from "@mui/material";
// import MDBox from "components/MDBox";
// import { Close as CloseIcon } from "@mui/icons-material";

// export default function ShowChatData(props) {
//   const chatArray = Object.values(props?.props?.chat || {});

//   console.log("chatArray", chatArray);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const handleClick = () => setIsModalOpen(true);
//   const handleClose = () => setIsModalOpen(false);

//   return (
//     <div>
//       {chatArray.length > 0 && (
//         <button onClick={handleClick} className="btn btn-danger btn-sm">
//           Open Chat
//         </button>
//       )}

//       {isModalOpen && (
//         <div style={styles.modalOverlay}>
//           <div style={styles.modal}>
//             <div style={styles.modalHeader}>
//               <IconButton onClick={handleClose} style={styles.closeButton}>
//                 <CloseIcon />
//               </IconButton>
//             </div>
//             <div style={styles.modalContent}>
//               <h4>Chat Messages</h4>
//               {chatArray.length > 0 ? (
//                 <MDBox>
//                   <TableContainer component={Paper}>
//                     <Table aria-label="chat table">
//                       <TableHead>
//                         <TableRow>
//                           <TableCell align="center">Admin ID</TableCell>
//                           <TableCell align="center">User ID</TableCell>
//                           <TableCell align="center">Message</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {chatArray.map((chat, index) => (
//                           <TableRow key={index}>
//                             <TableCell align="center">{chat?.adminId}</TableCell>
//                             <TableCell align="center">{chat?.userId}</TableCell>
//                             <TableCell align="center">{chat?.message}</TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </MDBox>
//               ) : (
//                 <div style={{ textAlign: "center", marginTop: "20px" }}>
//                   <p>Data not found</p>
//                 </div>
//               )}
//             </div>
//             <div style={styles.modalFooter}>
//               <button onClick={handleClose} className="btn btn-dark btn-sm">
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// const styles = {
//   modalOverlay: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 1000,
//   },
//   modal: {
//     backgroundColor: "#fff",
//     padding: "20px",
//     borderRadius: "5px",
//     width: "70%",
//     position: "relative",
//   },
//   modalHeader: {
//     display: "flex",
//     justifyContent: "flex-end",
//     marginBottom: "10px",
//   },
//   closeButton: {
//     fontSize: "24px",
//     color: "#333",
//   },
//   modalContent: {
//     marginBottom: "20px",
//   },
//   modalFooter: {
//     display: "flex",
//     justifyContent: "center",
//     marginTop: "20px",
//   },
// };

import React, { useState } from "react";
import { IconButton, Box, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

// Optional: Define a function to format the time (example, you can use moment.js or any date utility)
const formatTime = (time) => {
  if (!time) return "No time available";
  const date = new Date(time);
  return date.toLocaleTimeString(); // Format to your preference
};

export default function ShowChatData(props) {
  const chatArray = Object.values(props?.props?.chat || {}); // Ensure chatArray is always an array
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <div>
      {chatArray.length > 0 && (
        <button onClick={handleClick} className="btn btn-danger btn-sm">
          Open Chat
        </button>
      )}

      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <IconButton onClick={handleClose} style={styles.closeButton}>
                <CloseIcon />
              </IconButton>
            </div>
            <div style={styles.modalContent}>
              <h4>Chat Messages</h4>
              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: "auto",
                  padding: 1,
                  borderRadius: 3,
                }}
              >
                {chatArray.length === 0 ? (
                  <Typography variant="body2">No chat messages yet.</Typography>
                ) : (
                  chatArray.map((msg, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        flexDirection: msg.isAdmin ? "row-reverse" : "row",
                        alignItems: "center",
                        marginBottom: 1,
                      }}
                    >
                      <Box
                        sx={{
                          maxWidth: "70%",
                          wordWrap: "break-word",
                          backgroundColor: msg.isAdmin ? "#d1e7dd" : "#f8d7da",
                          borderRadius: 2,
                          padding: 1,
                          marginLeft: msg.isAdmin ? 0 : 1,
                          marginRight: msg.isAdmin ? 1 : 0,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ textAlign: msg.isAdmin ? "right" : "left" }}
                        >
                          {msg?.message}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ textAlign: msg.isAdmin ? "right" : "left", color: "gray" }}
                        >
                          {formatTime(msg.time)}
                        </Typography>
                      </Box>
                    </Box>
                  ))
                )}
              </Box>
            </div>
            <div style={styles.modalFooter}>
              <button onClick={handleClose} className="btn btn-dark btn-sm">
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "5px",
    width: "50%",
    position: "relative",
    overflowY: "auto",
    maxHeight: "80vh",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "10px",
  },
  closeButton: {
    fontSize: "24px",
    color: "#333",
  },
  modalContent: {
    marginBottom: "20px",
  },
  modalFooter: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
};
